enum ClueType {
  Color,
  Rank,
}
export default ClueType;
